import { Group, Image, Text } from '@mantine/core';
import { useAppName } from 'contexts/AppProvider';
import React from 'react';

const Brands = () => {
  const { appName } = useAppName();
  return (
    <Group mb={32} gap={4}>
      <Image src='/logo/logo_icon-dacum.svg' h={32} w={32} />
      <Text fw={700} fz={'xl'} tt={'uppercase'}>
        {appName}
      </Text>
    </Group>
  );
};

export default Brands;
